<template>
  <RankDivisionPicker
    :type="'currentRank'"
    item-key="placementBoost"
    :title="$t('calculators_common.previous_season_rank')"
    class="full-width"
    :show-server="true"
    :show-queue="true"
  />
  <RangePicker
    :title="$t('calculators_common.number_of_games')"
    :description="$t('calculators_common.select_number_of_games')"
    type="games-other"
    :max="5"
  />
  <option-picker />
</template>

<script setup>
import RangePicker from "../commonpickers/RangePicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import RankDivisionPicker from "./pickers/RankDivisionPicker.vue";
import { onMounted, watch } from "vue";

const {
  getDetails,
  setDetails,
  setPackExtraOptions,
  setServer,
  setPlatform,
  setGameAndPack,
  clearCheckout,
  setQueue,
  setCalculating,
} = useCheckoutStore();

const { getGame, getGamePack, getGameRanks } = useGameStore();

const handleDetails = () => {
  clearCheckout();

  if (getGameRanks.length > 0) {
    setDetails({
      currentRank: getGameRanks[0]?.id,
      currentRankTitle: getGameRanks[0]?.title,
      numberOfGames: 1,
    });
  }
  setPlatform({
    platform: 1,
  });

  setPackExtraOptions({
    lpGain: 19,
  });

  setServer("65");

  const option = getGamePack.pack_extra_options.find(
    (option) => option.description === "queue"
  );
  // $store.commit("setQueue", option?.id);
  setQueue(option?.id);

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  setCalculating();
});

watch(
  () => getGameRanks,
  (newVal) => {
    setDetails({
      currentRank: newVal[0]?.id,
      currentRankTitle: newVal[0]?.title,
      numberOfGames: 1,
    });
  }
);
</script>
